import { Mark, mergeAttributes } from '@tiptap/core'
import { sanitizeClassName } from './htmlAttrs'

/**
 * Class-only spans (for example Bootstrap labels) are not part of StarterKit
 * or TextStyle, so ProseMirror drops the tag the next time the document is
 * serialized. Keep the class list as its own mark.
 */
const Span = Mark.create({
  name: 'span',

  // Nested spans with different classes must both survive. The default
  // excludes the mark from itself, which would keep only the inner class.
  excludes: '',

  inclusive: false,

  exitable: true,

  keepOnSplit: false,

  parseHTML() {
    return [
      {
        tag: 'span',
        // TextStyle also matches span when it has a style. Leave the element
        // available so both the class and the style are kept.
        consuming: false,
        getAttrs: (element) => {
          if (!(element instanceof HTMLElement)) {
            return false
          }
          if (!sanitizeClassName(element.getAttribute('class'))) {
            return false
          }
          return null
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), 0]
  },

  addAttributes() {
    return {
      class: {
        default: null,
        parseHTML: (element) => sanitizeClassName(element.getAttribute('class')),
        renderHTML: (attributes) => {
          const className = sanitizeClassName(attributes.class)
          if (!className) {
            return {}
          }
          return { class: className }
        },
      },
    }
  },
})

export default Span
